import { defineAction } from "redux-define";
import { createAction } from "redux-actions";
import { LOADING, FAILURE, SUCCESS } from "./constants";

export const FETCH_DATA_REQUEST = 'FETCH_DATA_REQUEST';
export const FETCH_DATA_SUCCESS = 'FETCH_DATA_SUCCESS';
export const FETCH_DATA_ERROR = 'FETCH_DATA_ERROR';
export const CLEAR_GLOBAL_ERROR_MSG = 'CLEAR_GLOBAL_ERROR_MSG';

export const NEXT_STEP              = "NEXT_STEP";
export const SET_NAV_TAB            = "SET_NAV_TAB";
export const SET_SIDEBAR_MOBILE_OPEN = "SET_SIDEBAR_MOBILE_OPEN";

export const UPLOAD_FILE            = "UPLOAD_FILE";
export const DELETE_FILE            = "DELETE_FILE";

export const LOAD_LIST_COMPANY      = "LOAD_LIST_COMPANY";
export const LOAD_A_COMPANY         = "LOAD_A_COMPANY";
export const ADD_NEW_COMPANY        = "ADD_NEW_COMPANY";
export const UPDATE_A_COMPANY       = "UPDATE_A_COMPANY";
export const DELETE_A_COMPANY       = "DELETE_A_COMPANY";
export const CLEAR_A_COMPANY_DETAIL = "CLEAR_A_COMPANY_DETAIL";
export const SET_COMPANY_LOGO_FILE  = "SET_COMPANY_LOGO_FILE";
export const UPLOAD_COMPANY_LOGO_FILE = "UPLOAD_COMPANY_LOGO_FILE";
export const DELETE_COMPANY_LOGO_FILE = "DELETE_COMPANY_LOGO_FILE";
export const CLEAR_COMPANY_ACTION_STATUS = "CLEAR_COMPANY_ACTION_STATUS";

export const LOAD_LIST_USER         = "LOAD_LIST_USER";
export const LOAD_A_USER            = "LOAD_A_USER";
export const ADD_NEW_USER           = "ADD_NEW_USER";
export const UPDATE_A_USER          = "UPDATE_A_USER";
export const DELETE_A_USER          = "DELETE_A_USER";
export const CLEAR_USER_ACTION_STATUS = "CLEAR_USER_ACTION_STATUS";
export const CLEAR_A_USER_DETAIL      = "CLEAR_A_USER_DETAIL";

export const LOAD_LIST_DOCTOR                       = "LOAD_LIST_DOCTOR";
export const LOAD_A_DOCTOR                          = "LOAD_A_DOCTOR";
export const ADD_NEW_DOCTOR                         = "ADD_NEW_DOCTOR";
export const UPDATE_A_DOCTOR                        = "UPDATE_A_DOCTOR";
export const DELETE_A_DOCTOR                        = "DELETE_A_DOCTOR";
export const CLEAR_A_DOCTOR_DETAIL                  = "CLEAR_A_DOCTOR_DETAIL";
export const CLEAR_DOCTOR_ACTION_STATUS             = "CLEAR_DOCTOR_ACTION_STATUS";

export const LOAD_LIST_DEPARTMENT                   = "LOAD_LIST_DEPARTMENT";
export const LOAD_A_DEPARTMENT                      = "LOAD_A_DEPARTMENT";
export const ADD_NEW_DEPARTMENT                     = "ADD_NEW_DEPARTMENT";
export const UPDATE_A_DEPARTMENT                    = "UPDATE_A_DEPARTMENT";
export const DELETE_A_DEPARTMENT                    = "DELETE_A_DEPARTMENT";
export const CLEAR_A_DEPARTMENT_DETAIL              = "CLEAR_A_DEPARTMENT_DETAIL";
export const CLEAR_DEPARTMENT_ACTION_STATUS         = "CLEAR_DEPARTMENT_ACTION_STATUS";

export const LOAD_LIST_PATIENT                      = "LOAD_LIST_PATIENT";
export const LOAD_A_PATIENT                         = "LOAD_A_PATIENT";
export const ADD_NEW_PATIENT                        = "ADD_NEW_PATIENT";
export const UPDATE_A_PATIENT                       = "UPDATE_A_PATIENT";
export const DELETE_A_PATIENT                       = "DELETE_A_PATIENT";
export const CLEAR_LIST_PATIENT                     = "CLEAR_LIST_PATIENT";
export const CLEAR_A_PATIENT_DETAIL                 = "CLEAR_A_PATIENT_DETAIL";
export const CLEAR_PATIENT_ACTION_STATUS            = "CLEAR_PATIENT_ACTION_STATUS";
export const DOC_EXPORT_PATIENT_LIST_TO_CSV         = defineAction('DOC_EXPORT_PATIENT_LIST_TO_CSV',  [LOADING, FAILURE, SUCCESS], 'patients');
export const DOC_EXPORT_PATIENT_LIST_TO_EXCEL       = defineAction('DOC_EXPORT_PATIENT_LIST_TO_EXCEL',  [LOADING, FAILURE, SUCCESS], 'patients');
export const CLEAR_PATIENT_LIST_REMOTE_CSV          = "CLEAR_PATIENT_LIST_REMOTE_CSV";
export const CLEAR_PATIENT_LIST_REMOTE_EXCEL        = "CLEAR_PATIENT_LIST_REMOTE_EXCEL";

export const LOAD_LIST_SCHEDULE_MEDICAL             = "LOAD_LIST_SCHEDULE_MEDICAL";
export const LOAD_A_SCHEDULE_MEDICAL                = "LOAD_A_SCHEDULE_MEDICAL";
export const ADD_NEW_SCHEDULE_MEDICAL               = "ADD_NEW_SCHEDULE_MEDICAL";
export const UPDATE_A_SCHEDULE_MEDICAL              = "UPDATE_A_SCHEDULE_MEDICAL";
export const DELETE_A_SCHEDULE_MEDICAL              = "DELETE_A_SCHEDULE_MEDICAL";
export const CLEAR_A_SCHEDULE_MEDICAL_DETAIL        = "CLEAR_A_SCHEDULE_MEDICAL_DETAIL";
export const CLEAR_SCHEDULE_MEDICAL_ACTION_STATUS   = "CLEAR_SCHEDULE_MEDICAL_ACTION_STATUS";

export const LOAD_LIST_PATIENT_RESULT               = "LOAD_LIST_PATIENT_RESULT";
export const LOAD_A_PATIENT_RESULT                  = "LOAD_A_PATIENT_RESULT";
export const ADD_NEW_PATIENT_RESULT                 = "ADD_NEW_PATIENT_RESULT";
export const UPDATE_A_PATIENT_RESULT                = "UPDATE_A_PATIENT_RESULT";
export const DELETE_A_PATIENT_RESULT                = "DELETE_A_PATIENT_RESULT";
export const CLEAR_A_PATIENT_RESULT_DETAIL          = "CLEAR_A_PATIENT_RESULT_DETAIL";
export const CLEAR_PATIENT_RESULT_ACTION_STATUS     = "CLEAR_PATIENT_RESULT_ACTION_STATUS";
export const EXPORT_MEDICINE_TO_PDF                 = "EXPORT_MEDICINE_TO_PDF";
export const CLEAR_MEDICINE_TO_PDF                  = "CLEAR_MEDICINE_TO_PDF";

export const LOAD_LIST_SERVICE_PRICE                = "LOAD_LIST_SERVICE_PRICE";
export const LOAD_A_SERVICE_PRICE                   = "LOAD_A_SERVICE_PRICE";
export const ADD_NEW_SERVICE_PRICE                  = "ADD_NEW_SERVICE_PRICE";
export const UPDATE_A_SERVICE_PRICE                 = "UPDATE_A_SERVICE_PRICE";
export const DELETE_A_SERVICE_PRICE                 = "DELETE_A_SERVICE_PRICE";
export const CLEAR_A_SERVICE_PRICE_DETAIL           = "CLEAR_A_SERVICE_PRICE_DETAIL";
export const CLEAR_SERVICE_PRICE_ACTION_STATUS      = "CLEAR_SERVICE_PRICE_ACTION_STATUS";
export const DOC_EXPORT_SERVICE_PRICE_LIST_TO_CSV   = defineAction('DOC_EXPORT_SERVICE_PRICE_LIST_TO_CSV',  [LOADING, FAILURE, SUCCESS], 'patients');
export const DOC_EXPORT_SERVICE_PRICE_LIST_TO_EXCEL = defineAction('DOC_EXPORT_SERVICE_PRICE_LIST_TO_EXCEL',  [LOADING, FAILURE, SUCCESS], 'patients');
export const CLEAR_SERVICE_PRICE_LIST_REMOTE_CSV    = "CLEAR_SERVICE_PRICE_LIST_REMOTE_CSV";
export const CLEAR_SERVICE_PRICE_LIST_REMOTE_EXCEL  = "CLEAR_SERVICE_PRICE_LIST_REMOTE_EXCEL";

export const LOAD_LIST_MEDICINE                     = "LOAD_LIST_MEDICINE";
export const LOAD_A_MEDICINE                        = "LOAD_A_MEDICINE";
export const ADD_NEW_MEDICINE                       = "ADD_NEW_MEDICINE";
export const UPDATE_A_MEDICINE                      = "UPDATE_A_MEDICINE";
export const DELETE_A_MEDICINE                      = "DELETE_A_MEDICINE";
export const CLEAR_A_MEDICINE_DETAIL                = "CLEAR_A_MEDICINE_DETAIL";
export const CLEAR_MEDICINE_ACTION_STATUS           = "CLEAR_MEDICINE_ACTION_STATUS";
export const UPDATE_LIST_MEDICINE_WHEN_IMPORT_EXPORT = "UPDATE_LIST_MEDICINE_WHEN_IMPORT_EXPORT";
export const DOC_EXPORT_MEDICINE_LIST_TO_CSV        = defineAction('DOC_EXPORT_MEDICINE_LIST_TO_CSV',  [LOADING, FAILURE, SUCCESS], 'patients');
export const DOC_EXPORT_MEDICINE_LIST_TO_EXCEL      = defineAction('DOC_EXPORT_MEDICINE_LIST_TO_EXCEL',  [LOADING, FAILURE, SUCCESS], 'patients');
export const CLEAR_MEDICINE_LIST_REMOTE_CSV         = "CLEAR_MEDICINE_LIST_REMOTE_CSV";
export const CLEAR_MEDICINE_LIST_REMOTE_EXCEL       = "CLEAR_MEDICINE_LIST_REMOTE_EXCEL";

export const LOAD_LIST_MEDICINE_IMPORT_EXPORT       = "LOAD_LIST_MEDICINE_IMPORT_EXPORT";
export const LOAD_A_MEDICINE_IMPORT_EXPORT          = "LOAD_A_MEDICINE_IMPORT_EXPORT";
export const ADD_NEW_MEDICINE_IMPORT_EXPORT         = "ADD_NEW_MEDICINE_IMPORT_EXPORT";
export const UPDATE_A_MEDICINE_IMPORT_EXPORT        = "UPDATE_A_MEDICINE_IMPORT_EXPORT";
export const DELETE_A_MEDICINE_IMPORT_EXPORT        = "DELETE_A_MEDICINE_IMPORT_EXPORT";

export const LOAD_LIST_ENTERPRISE                   = "LOAD_LIST_ENTERPRISE";
export const LOAD_A_ENTERPRISE                      = "LOAD_A_ENTERPRISE";
export const ADD_NEW_ENTERPRISE                     = "ADD_NEW_ENTERPRISE";
export const UPDATE_A_ENTERPRISE                    = "UPDATE_A_ENTERPRISE";
export const DELETE_A_ENTERPRISE                    = "DELETE_A_ENTERPRISE";
export const CLEAR_A_ENTERPRISE_DETAIL              = "CLEAR_A_ENTERPRISE_DETAIL";
export const CLEAR_ENTERPRISE_ACTION_STATUS         = "CLEAR_ENTERPRISE_ACTION_STATUS";

export const LOAD_A_SYSTEM_SETTING                  = "LOAD_A_SYSTEM_SETTING";
export const ADD_NEW_SYSTEM_SETTING                 = "ADD_NEW_SYSTEM_SETTING";
export const UPDATE_A_SYSTEM_SETTING                = "UPDATE_A_SYSTEM_SETTING";
export const DELETE_A_SYSTEM_SETTING                = "DELETE_A_SYSTEM_SETTING";
export const CLEAR_A_SYSTEM_SETTING_DETAIL          = "CLEAR_A_SYSTEM_SETTING_DETAIL";
export const CLEAR_SYSTEM_SETTING_ACTION_STATUS     = "CLEAR_SYSTEM_SETTING_ACTION_STATUS";

export const LOAD_LIST_PAYMENT                      = "LOAD_LIST_PAYMENT";

export const LOAD_LIST_USER_LOG                     = "LOAD_LIST_USER_LOG";